import React, { useRef, useEffect } from "react";
import { lang } from "../lang";

// Component for task name input
function TaskNameInput({
  task,
  onUpdateTask,
  addTaskOnEnter,
  parentId,
  onAddTask,
}) {
  const [name, setName] = React.useState(task.name);
  const inputRef = useRef(null);

  // Expose focus method
  const focus = () => {
    if (inputRef.current) {
      inputRef.current.focus();
      if (process.env.NODE_ENV === "development") {
        console.log("Focusing input for task:", task.id);
      }
    }
  };

  // Auto-focus new tasks
  useEffect(() => {
    if (task.isNew) {
      focus();
      // Clear isNew flag after focusing
      onUpdateTask(task.id, { isNew: false });
    }
  }, [task.isNew, task.id, onUpdateTask]);

  const handleChange = (e) => {
    setName(e.target.value);
  };

  const handleBlur = () => {
    if (name !== task.name) {
      onUpdateTask(task.id, { name });
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && name.trim()) {
      handleBlur();
      if (addTaskOnEnter && !task.isRest && !task.completed) {
        const newTask = {
          id:
            Date.now().toString() +
            "-" +
            Math.random().toString(36).substr(2, 9),
          name: lang.task.newTask,
          duration: task.duration,
          remaining: task.duration,
          paused: true,
          completed: false,
          children: [],
          isRest: false,
          tags: [],
          notes: "",
          isNew: true,
        };
        if (process.env.NODE_ENV === "development") {
          console.log("Adding new task on Enter:", newTask);
        }
        onAddTask(parentId, newTask);
      }
    }
  };

  return (
    <input
      ref={inputRef}
      type="text"
      value={name}
      onChange={handleChange}
      onBlur={handleBlur}
      onKeyDown={handleKeyDown}
      placeholder={lang.task.placeholder}
    />
  );
}

export default TaskNameInput;
